import * as React from "react";
const SvgStrokeSolid = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 13H2V11H22V13Z", fill: "currentColor" }));
export default SvgStrokeSolid;
